import { render, staticRenderFns } from "./addLeaderInfo.vue?vue&type=template&id=437859ea&"
import script from "./addLeaderInfo.vue?vue&type=script&lang=js&"
export * from "./addLeaderInfo.vue?vue&type=script&lang=js&"
import style0 from "./addLeaderInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports